define.alias("ember-math-helpers/helpers/div", "settings/helpers/div");